import axios from "axios";

const baseURL = import.meta.env.VITE_API_BASE_URL;

const axiosInstance = axios.create({
  baseURL,
});

axiosInstance.interceptors.request.use(async (config) => {
  // console.log(import.meta.env.VITE_API_BASE_URL, " base url");
  let token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = 'Bearer ' + token;
  } else {
    delete config.headers.Authorization;
  }

  if (String(baseURL || "").includes("ngrok")) {
    config.headers['ngrok-skip-browser-warning'] = true;
  } else {
    delete config.headers['ngrok-skip-browser-warning'];
  }

  return config;
}, async (error) => {
  return Promise.reject(error);
});


axiosInstance.interceptors.response.use(async (response) => {
  return response;
}, async (error) => {
  throw error;
});


export { axiosInstance };
